import CryptoJS from 'crypto-js';

// Function to encrypt JSON
const encryptJSON = (json, secretKey) => {
  const jsonString = JSON.stringify(json);
  const encrypted = CryptoJS.AES.encrypt(jsonString, secretKey).toString();
  return encrypted;
};

export default encryptJSON;
